// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .help__text {\n  display: -webkit-inline-box;\n  position: absolute;\n  color: white;\n  left: 50%;\n  margin-left: -20%;\n  top: 50%;\n  margin-top: -20%;\n} */\n\n._1xZNA {\n  color: #fff;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin-top: 43vh;\n  font-weight: 600;\n  font-size: 16px;\n}\n", ""]);
// Exports
exports.locals = {
	"help__text": "_1xZNA"
};
module.exports = exports;
